export default import.meta.ROLLDOWN_FILE_URL_cLLFq7OX38PQjR0WE41fig